"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PencilIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const PencilIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props),
    react_1.default.createElement("path", { d: "M14.8492 1.41421C14.0682 0.633165 12.8019 0.633165 12.0208 1.41421L11.3137 2.12132L14.1421 4.94975L14.8492 4.24264C15.6303 3.46159 15.6303 2.19526 14.8492 1.41421Z" }),
    react_1.default.createElement("path", { d: "M12.7279 6.36396L9.89949 3.53553L2.12132 11.3137L1.5613 14.1138C1.49133 14.4637 1.79979 14.7721 2.14965 14.7022L4.94975 14.1421L12.7279 6.36396Z" })));
exports.PencilIcon = PencilIcon;
exports.default = exports.PencilIcon;
